import React from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { blogPosts } from "./BlogData";
import ReactMarkdown from "react-markdown";
import { Helmet } from "react-helmet";
import remarkGfm from "remark-gfm";
import GoogleAd from "../ads/GoogleAd";

function BlogPost() {
  const { id } = useParams();
  const post = blogPosts.find((item) => item.id.toString() === id);

  if (!post) return <h2 className="text-center mt-5 text-light">Blog not found</h2>;

  const paragraphs = post.fullContent.split("\n\n"); // divise les paragraphes

  // Choisis un point pour insérer la publicité (par exemple après le 4e paragraphe)
  const insertAt = 4;

  const contentWithAds = paragraphs.flatMap((para, index) =>
    index === insertAt
      ? [
          <ReactMarkdown key={index} children={para} remarkPlugins={[remarkGfm]} />,
          <GoogleAd key="ad" adSlot="5678184118" />,
        ]
      : [<ReactMarkdown key={index} children={para} remarkPlugins={[remarkGfm]} />]
  );

  return (
    <>
      <Helmet>
  <title>{post.title} | Raed Madouri</title>
  <meta name="description" content={post.summary} />
  <meta name="keywords" content={post.keywords || ""} />
  <meta property="og:title" content={post.title} />
  <meta property="og:description" content={post.summary} />
  <meta property="og:image" content={post.image || "https://www.raedmadouri.com/default.jpg"} />
  <meta property="og:url" content={`https://www.raedmadouri.com/blog/${post.id}`} />
  <meta property="og:type" content="article" />
</Helmet>

      <Container className="blog-post-container mt-5 pt-5 pb-5 text-light" style={{ maxWidth: "960px" }}>
      <GoogleAd adSlot="3961777764" adFormat="autorelaxed" />
        <h1 className="mb-3">{post.title}</h1>
        <p className="text-muted">{post.date}</p>
        <hr />
        {contentWithAds}
        <GoogleAd adSlot="3961777764" adFormat="autorelaxed" />
      </Container>
    </>
  );
}

export default BlogPost;
